export default __webpack_public_path__ + "static/media/logo1Final.a1367d41.png";